<template>
  <v-app id="login" class="primary darken-2">
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4 lg4>
          <v-card class="elevation-4 pa-6">
            <v-card-text>
              <div class="layout column align-center pa-1 ma-2">
                <img v-if="logo" :src="logo" alt="SIRH" width="90%" />
              </div>
              <v-form ref="form">
                <v-text-field
                  v-model="login.usuario"
                  label="Usuario"
                  :rules="fieldRequired"
                  required
                  dense/>
                <v-text-field
                  v-model="login.password"
                  label="Contraseña"
                  :append-icon="showeye ? 'visibility' : 'visibility_off'"
                  :append-icon-cb="() => (value = !value)"
                  :rules="fieldRequired"
                  required
                  :type="showeye ? 'text' : 'password'"
                  @click:append="showeye = !showeye"
                  @keyup.enter="loginAccess"
                />
              </v-form>
              <Recaptcha :on-success="submit" class="recaptcha"/>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn :disabled="!valid" color="success"  @click="loginAccess">Login</v-btn>
            </v-card-actions>
            <v-progress-linear
              :active="loading"
              :indeterminate="true"
              absolute
              bottom
              color="primary darken-2 accent-4">
            </v-progress-linear>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { Validate } from '@/mixins/validateFormMixin'
import router from '@/router'
import Recaptcha from '@/components/fields/Recaptcha'
export default {
  name: 'login',
  mixins: [Validate],
  props: {
    source: String
  },
  data: () => ({
    logo: null,
    valid: true,
    showeye: false,
    loger: null,
    login: {
      usuario: '',
      password: ''
    },
    loading: false
  }),
  components: {
    Recaptcha
  },
  mounted () {
  },
  beforeMount () {
    this.GETUrlLogoSistema('logo')
  },
  methods: {
    loginAccess () {
      if (this.$refs.form.validate()) {
        this.sendLogin('POST/login')
        this.loading = true
      } else {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error!',
          text: 'Campos Requeridos'
        })
      }
    },
    ...mapActions(['getUrlServices', 'urlPostServiceLoginAction', 'GETUrlLogoSistema']),
    sendLogin (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.urlPostServiceLoginAction({ url: router, data: this.login })
      } else {
        this.getUrlServices()
      }
    },
    submit (results) { this.login.captcha = results },
    ...mapMutations([])
  },
  computed: {
    ...mapGetters(['get_urls', 'get_objectAccess', 'get_logo'])
  },
  watch: {
    get_urls (vals) {
      this.sendLogin('POST/login')
    },
    get_objectAccess (val) {
      this.loading = false
      if (val.message) {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error!',
          text: val.message
        })
        return
      }
      this.$cookies.set('token_sirh', val.access_token)
      const user = {
        usuario: val.user.usuario,
        id: val.user.id,
        cve_empleado: val.user.cve_empleado,
        empleado: val.user.empleado.NombreCompleto,
        email: val.user.email
      }
      this.$cookies.set('user_sirh', user)
      localStorage.setItem('permisos', JSON.stringify(val.user.roles[0]))
      router.push({ name: 'home' })
    },
    get_logo (logo) {
      this.logo = `${logo.formato}${logo.imagen}`
    }
  }
}
</script>

<style scoped lang="css">
  #login {
    height: 50%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
  }
  .verde{
    background: #009B37;
  }
</style>
